var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('h3',[_vm._v("Módulo de Cuenta de Usuario")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }